import Bluebird from 'bluebird';
import * as $ from 'jquery';
import { $class } from '../../services/jquery-utils';
import getTranslations from '../../services/translations';
import fetchUserConfig from '../../services/user-config';
import { isAndroid, isDesktop } from './storage';

export default async function loadInputs(): Bluebird<void> {
    // Vandaag string (13-01-2016)
    const d = new Date();
    const month = d.getMonth() + 1, day = d.getDate();
    const yearStr = d.getFullYear(), monthStr = `${((`${month}`).length < 2 ? '0' : '')}${month}`,
        dayStr = `${((`${day}`).length < 2 ? '0' : '')}${day}`;

    // Input focus
    if (!isDesktop) {
        const t = await getTranslations('widget');
        const $inputs = {
            fromHome: t['preview.address'],
            flightNumber: t['preview.flightnum'],
            flightDate: `${dayStr}-${monthStr}-${yearStr}`,
            toHotel: t['preview.address']
        };

        // Placeholders onfocus
        $.each($inputs, (id, placeholder) => {
            const $input = $(`.${id}`),
                phBegin = $input.prop('placeholder');

            $input.on('focus', function () {
                const $this = $(this);
                $this.prop('placeholder', placeholder);
                $this.siblings('.field-label').show();
            });

            $input.on('focusout', function () {
                const $this = $(this);
                $this.prop('placeholder', phBegin);

                if ($this.val() === '') {
                    $this.siblings('.field-label').hide();
                }
            });
        });
    }

    // Datumvelden type onfocus (text/date)
    const defaultDate = `${yearStr}-${monthStr}-${dayStr}`;
    const $flightDate = $('.flightDate');
    if (isAndroid && !isDesktop) {
        $flightDate.prop('type', 'date').val(defaultDate).change(function () {
            $(this).blur();
        });
    }

    const $searchBtn = $('.search-flight-btn');
    $searchBtn.click(() => $flightDate.blur());
    $flightDate.focus(() => $searchBtn.removeClass('hidden'))
        .blur(() => $searchBtn.addClass('hidden'));

    $('.inputDiv')
        .on('focusin', '.flightDate[type="text"]', function () {
            if (isDesktop || isAndroid) return;
            $(this).blur().prop('type', 'date').focus();
        })
        .on('focusout', '.flightDate[type="date"]', function () {
            if (($(this).val() as string).trim() === '') {
                if (!isDesktop) $searchBtn.addClass('hidden');

                if (isAndroid && !isDesktop) {
                    $(this).val(defaultDate);
                } else {
                    $(this).prop('type', 'text');
                }
            }
        });

    $('.noflight-date').blur(function () {
        $(this).next('select').focus();
    });

    // UTC labels
    const { useUTC } = await fetchUserConfig();

    if (useUTC) {
        $class('utc-hidden').hide();
        $class('utc-shown').show();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/inputs-loader.ts